import { sectionRenderer } from '@theme/section-renderer';
import { RecentlyViewed } from './recently-viewed-products.js';

class BbdRecentlyViewedProducts extends HTMLElement {
  connectedCallback() {
    this.#loadRecentlyViewed();
  }

  async #loadRecentlyViewed() {
    const storedProducts = RecentlyViewed.getProducts();
    const maxProducts = parseInt(this.dataset.maxProducts || '8', 10);

    // Filter out duplicates and limit to maxProducts
    const productIds = [...new Set(storedProducts)].slice(0, maxProducts);

    // Only display when we have at least 3 recently viewed products
    if (productIds.length < 3) {
      this.classList.add('hidden');
      return;
    }

    const searchQuery = productIds.map((id) => `id:${id}`).join(' OR ');
    const sectionId = this.dataset.sectionId;

    // eslint-disable-next-line
    const url = new URL(Theme.routes.predictive_search_url, window.location.origin);
    url.searchParams.set('q', searchQuery);
    url.searchParams.set('resources[type]', 'product');

    try {
      const htmlText = await sectionRenderer.getSectionHTML(sectionId, false, url);
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlText, 'text/html');
      const newSection = doc.querySelector(`bbd-recently-viewed-products[id="${this.id}"]`);

      if (newSection && newSection.innerHTML.trim().length) {
        this.innerHTML = newSection.innerHTML;
        const datalayerObserver = new IntersectionObserver(
          (entries, obs) => {
            if (!entries[0]?.isIntersecting) return;
            obs.disconnect();
            this.dispatchEvent(new CustomEvent('datalayer:list-ready', { bubbles: true, detail: { container: this } }));
          },
          { rootMargin: '0px 0px 200px 0px' }
        );
        datalayerObserver.observe(this);
        // Clear the last-collection breadcrumb key when navigating from recently
        // viewed, as the product was not reached via a collection browse.
        this.addEventListener('click', (event) => {
          if (event.target.closest('a')) {
            localStorage.removeItem('bbd_last_collection');
          }
        });
      } else {
        this.classList.add('hidden');
      }
    } catch (error) {
      console.error('BBD Recently Viewed Products error:', error);
      this.classList.add('hidden');
    }
  }
}

if (!customElements.get('bbd-recently-viewed-products')) {
  customElements.define('bbd-recently-viewed-products', BbdRecentlyViewedProducts);
}
